import { PageLayout } from '@/shared/layout/PageLayout';
import { cn } from '@/utils/cn';
import { ReactNode } from 'react';

interface StandardListLayoutProps {
  title: string;
  description: string;
  isLoading?: boolean;
  actions?: ReactNode;
  kpiSection?: ReactNode;
  toolbarSection: ReactNode;
  tableSection: ReactNode;
  cardSection: ReactNode;
  sidePanel?: ReactNode;
  viewMode?: 'table' | 'card' | 'compact';
  children?: ReactNode;
}

export function StandardListLayout({
  title,
  description,
  isLoading,
  actions,
  kpiSection,
  toolbarSection,
  tableSection,
  cardSection,
  sidePanel,
  viewMode = 'table',
  children,
}: StandardListLayoutProps) {
  return (
    <PageLayout
      title={title}
      description={description}
      isLoading={isLoading}
      actions={actions}
    >
      <div className="flex h-full gap-6 relative">
        <div className="flex-1 flex flex-col min-w-0 gap-6">
          {/* KPI Section */}
          {kpiSection && <div>{kpiSection}</div>}

          {/* Toolbar Section */}
          <div className="flex flex-col">
            {toolbarSection}
          </div>

          {/* List Section */}
          <div className="flex-1 overflow-y-auto min-h-0 bg-white border border-slate-200 rounded-md p-0 md:p-3">
            {/* Desktop Table View */}
            <div className={cn("hidden h-full", viewMode === 'table' && "md:block")}>
              {tableSection}
            </div>
            
            {/* Mobile Card View (or Desktop when viewMode is card) */}
            <div className={cn("h-full", viewMode === 'table' ? "block md:hidden p-3" : "block")}>
              {cardSection}
            </div>
          </div>
        </div>
        
        {/* Side Panel (e.g. Quick Detail view) */}
        {sidePanel && (
          <div className="hidden lg:block w-96 shrink-0 h-full overflow-hidden bg-white border border-slate-200 rounded-lg shadow-sm">
            {sidePanel}
          </div>
        )}
        
        {/* Mobile slide-over version of Side Panel could be handled by the child component itself via Portal or fixed positioning */}
      </div>
      {children}
    </PageLayout>
  );
}
